<div class="modal-content-wrapper">
  <p class="titulo">
    <ng-container *ngIf="itens?.length === 1; else plural">
      {{ tituloSingular }}
    </ng-container>
    <ng-template #plural>
      {{ tituloPlural }}
    </ng-template>
  </p>

  <ul class="lista-itens mt-4" style="max-height: 500px; overflow-y: auto;">
    <li *ngFor="let item of itens">{{ item }}</li>
  </ul>
</div>
